// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Table Styles
 * Consistent table layout for all management pages
 */

/* Unified Table Responsive */
.unified-table-responsive {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    margin: 0 25px 30px 25px;
}

/* Unified Table */
.unified-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    min-width: 1400px;
}

.unified-table th {
    background: #252A33;
    color: white;
    font-weight: 600;
    padding: 16px;
    text-align: left;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}

.unified-table th:first-child {
    text-align: center;
    width: 50px;
}

.unified-table td {
    padding: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    color: #2d3748;
    font-size: 0.875rem;
}

.unified-table tr:hover {
    background: #F7F7F8;
}

.unified-table tr:last-child td {
    border-bottom: none;
}

/* Enhanced Selection Styles */
.unified-table-row {
    cursor: pointer;
    transition: all 0.2s ease;
}

.unified-table-row.selected {
    background: #FFF7ED;
    border-left: 4px solid #EA580C;
    box-shadow: 0 2px 8px rgba(249, 115, 22, 0.2);
}

.unified-table-row.selected:hover {
    background: #FFF2E5;
}

.unified-table-row:hover {
    background: #F7F7F8;
    transform: translateY(-1px);
}

/* Select Column Styles */
.unified-table-select-header {
    text-align: center;
    width: 50px;
}

.unified-table-select-cell {
    position: relative;
    text-align: center;
}

.unified-table-select-cell input[type="checkbox"] {
    transform: scale(1.2);
    cursor: pointer;
}

.unified-table-select-cell input[type="checkbox"]:checked {
    accent-color: #EA580C;
}

/* Table Element Styles */
.unified-table .unified-contact-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.unified-table .unified-contact-name {
    font-weight: 600;
    color: #2d3748;
    font-size: 0.9rem;
}

.unified-table .unified-contact-role {
    font-size: 0.8rem;
    color: #718096;
    font-style: italic;
}

.unified-table .unified-location-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.unified-table .unified-city-state {
    font-weight: 500;
    color: #2d3748;
    font-size: 0.9rem;
}

.unified-table .unified-postcode {
    font-size: 0.8rem;
    color: #718096;
}

.unified-table .unified-membership-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.unified-table .unified-membership-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
}

.unified-table .unified-membership-badge.active {
    background: rgba(56, 161, 105, 0.1);
    color: #38a169;
}

.unified-table .unified-membership-badge.pending {
    background: rgba(214, 158, 46, 0.1);
    color: #d69e2e;
}

.unified-table .unified-membership-badge.expired {
    background: rgba(229, 62, 62, 0.1);
    color: #e53e3e;
}

.unified-table .unified-status-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.unified-table .unified-payment-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.unified-table .unified-payment-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
}

.unified-table .unified-payment-badge.current {
    background: rgba(56, 161, 105, 0.1);
    color: #38a169;
}

.unified-table .unified-payment-badge.overdue {
    background: rgba(229, 62, 62, 0.1);
    color: #e53e3e;
}

.unified-table .unified-payment-badge.pending {
    background: rgba(214, 158, 46, 0.1);
    color: #d69e2e;
}

.unified-table .unified-outstanding-balance {
    font-size: 0.8rem;
    color: #4a5568;
    font-weight: 500;
}

.unified-table .unified-sync-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.unified-table .unified-sync-status,
.unified-table .unified-mailchimp-sync {
    display: flex;
    align-items: center;
    gap: 8px;
}

.unified-table .sync-label {
    font-size: 0.75rem;
    font-weight: 500;
    color: #4a5568;
    min-width: 100px;
}

.unified-table .unified-sync-status,
.unified-table .unified-mailchimp-sync {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unified-table .sync-label {
    font-size: 0.7rem;
    color: #718096;
    font-weight: 500;
    min-width: 90px;
}

.unified-table .unified-sync-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
    white-space: nowrap;
}

.unified-table .unified-sync-badge.synced {
    background: rgba(56, 161, 105, 0.1);
    color: #38a169;
}

.unified-table .unified-sync-badge.failed,
.unified-table .unified-sync-badge.error {
    background: rgba(229, 62, 62, 0.1);
    color: #e53e3e;
}

.unified-table .unified-sync-badge.pending {
    background: rgba(214, 158, 46, 0.1);
    color: #d69e2e;
}

.unified-table .unified-sync-badge.never,
.unified-table .unified-sync-badge.not_synced {
    background: rgba(160, 174, 192, 0.1);
    color: #a0aec0;
}

.unified-table .unified-member-id {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.9rem;
    font-weight: 600;
    color: #0D3B66;
}

.unified-table .unified-organization-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.unified-table .unified-org-name {
    font-weight: 600;
    color: #2d3748;
}

.unified-table .unified-email-link {
    color: #0D3B66;
    text-decoration: none;
    font-weight: 500;
}

.unified-table .unified-email-link:hover {
    text-decoration: underline;
}

.unified-table .unified-status-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: black;
}

.unified-table .unified-status-badge.active {
    background: #38a169;
}

.unified-table .unified-status-badge.inactive {
    background: #e53e3e;
}

.unified-table .unified-status-badge.suspended {
    background: #d69e2e;
}

.unified-table .unified-status-badge.expired {
    background: #e53e3e;
}

/* Responsive Design */
@media (max-width: 768px) {
    .unified-table-responsive {
        margin: 0 20px 20px 20px;
        overflow-x: auto;
    }

    .unified-table {
        min-width: 1200px;
    }
}

@media (max-width: 480px) {
    .unified-table-responsive {
        margin: 0 15px 15px 15px;
    }
}

/* Screen reader only text - visually hidden but accessible to screen readers */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedTable.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,6BAA6B;AAC7B;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,wDAAwD;IACxD,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb","sourcesContent":["/**\n * Unified Table Styles\n * Consistent table layout for all management pages\n */\n\n/* Unified Table Responsive */\n.unified-table-responsive {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    margin: 0 25px 30px 25px;\n}\n\n/* Unified Table */\n.unified-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n    min-width: 1400px;\n}\n\n.unified-table th {\n    background: #252A33;\n    color: white;\n    font-weight: 600;\n    padding: 16px;\n    text-align: left;\n    font-size: 0.875rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.unified-table th:first-child {\n    text-align: center;\n    width: 50px;\n}\n\n.unified-table td {\n    padding: 16px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    color: #2d3748;\n    font-size: 0.875rem;\n}\n\n.unified-table tr:hover {\n    background: #F7F7F8;\n}\n\n.unified-table tr:last-child td {\n    border-bottom: none;\n}\n\n/* Enhanced Selection Styles */\n.unified-table-row {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.unified-table-row.selected {\n    background: #FFF7ED;\n    border-left: 4px solid #EA580C;\n    box-shadow: 0 2px 8px rgba(249, 115, 22, 0.2);\n}\n\n.unified-table-row.selected:hover {\n    background: #FFF2E5;\n}\n\n.unified-table-row:hover {\n    background: #F7F7F8;\n    transform: translateY(-1px);\n}\n\n/* Select Column Styles */\n.unified-table-select-header {\n    text-align: center;\n    width: 50px;\n}\n\n.unified-table-select-cell {\n    position: relative;\n    text-align: center;\n}\n\n.unified-table-select-cell input[type=\"checkbox\"] {\n    transform: scale(1.2);\n    cursor: pointer;\n}\n\n.unified-table-select-cell input[type=\"checkbox\"]:checked {\n    accent-color: #EA580C;\n}\n\n/* Table Element Styles */\n.unified-table .unified-contact-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.unified-table .unified-contact-name {\n    font-weight: 600;\n    color: #2d3748;\n    font-size: 0.9rem;\n}\n\n.unified-table .unified-contact-role {\n    font-size: 0.8rem;\n    color: #718096;\n    font-style: italic;\n}\n\n.unified-table .unified-location-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.unified-table .unified-city-state {\n    font-weight: 500;\n    color: #2d3748;\n    font-size: 0.9rem;\n}\n\n.unified-table .unified-postcode {\n    font-size: 0.8rem;\n    color: #718096;\n}\n\n.unified-table .unified-membership-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.unified-table .unified-membership-badge {\n    display: inline-block;\n    padding: 2px 6px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.unified-table .unified-membership-badge.active {\n    background: rgba(56, 161, 105, 0.1);\n    color: #38a169;\n}\n\n.unified-table .unified-membership-badge.pending {\n    background: rgba(214, 158, 46, 0.1);\n    color: #d69e2e;\n}\n\n.unified-table .unified-membership-badge.expired {\n    background: rgba(229, 62, 62, 0.1);\n    color: #e53e3e;\n}\n\n.unified-table .unified-status-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.unified-table .unified-payment-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.unified-table .unified-payment-badge {\n    display: inline-block;\n    padding: 2px 6px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.unified-table .unified-payment-badge.current {\n    background: rgba(56, 161, 105, 0.1);\n    color: #38a169;\n}\n\n.unified-table .unified-payment-badge.overdue {\n    background: rgba(229, 62, 62, 0.1);\n    color: #e53e3e;\n}\n\n.unified-table .unified-payment-badge.pending {\n    background: rgba(214, 158, 46, 0.1);\n    color: #d69e2e;\n}\n\n.unified-table .unified-outstanding-balance {\n    font-size: 0.8rem;\n    color: #4a5568;\n    font-weight: 500;\n}\n\n.unified-table .unified-sync-info {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.unified-table .unified-sync-status,\n.unified-table .unified-mailchimp-sync {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.unified-table .sync-label {\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #4a5568;\n    min-width: 100px;\n}\n\n.unified-table .unified-sync-status,\n.unified-table .unified-mailchimp-sync {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.unified-table .sync-label {\n    font-size: 0.7rem;\n    color: #718096;\n    font-weight: 500;\n    min-width: 90px;\n}\n\n.unified-table .unified-sync-badge {\n    display: inline-block;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: capitalize;\n    white-space: nowrap;\n}\n\n.unified-table .unified-sync-badge.synced {\n    background: rgba(56, 161, 105, 0.1);\n    color: #38a169;\n}\n\n.unified-table .unified-sync-badge.failed,\n.unified-table .unified-sync-badge.error {\n    background: rgba(229, 62, 62, 0.1);\n    color: #e53e3e;\n}\n\n.unified-table .unified-sync-badge.pending {\n    background: rgba(214, 158, 46, 0.1);\n    color: #d69e2e;\n}\n\n.unified-table .unified-sync-badge.never,\n.unified-table .unified-sync-badge.not_synced {\n    background: rgba(160, 174, 192, 0.1);\n    color: #a0aec0;\n}\n\n.unified-table .unified-member-id {\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #0D3B66;\n}\n\n.unified-table .unified-organization-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.unified-table .unified-org-name {\n    font-weight: 600;\n    color: #2d3748;\n}\n\n.unified-table .unified-email-link {\n    color: #0D3B66;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.unified-table .unified-email-link:hover {\n    text-decoration: underline;\n}\n\n.unified-table .unified-status-badge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: black;\n}\n\n.unified-table .unified-status-badge.active {\n    background: #38a169;\n}\n\n.unified-table .unified-status-badge.inactive {\n    background: #e53e3e;\n}\n\n.unified-table .unified-status-badge.suspended {\n    background: #d69e2e;\n}\n\n.unified-table .unified-status-badge.expired {\n    background: #e53e3e;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .unified-table-responsive {\n        margin: 0 20px 20px 20px;\n        overflow-x: auto;\n    }\n\n    .unified-table {\n        min-width: 1200px;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-table-responsive {\n        margin: 0 15px 15px 15px;\n    }\n}\n\n/* Screen reader only text - visually hidden but accessible to screen readers */\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
